import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export function useUserRole() {
  const { user } = useAuth();
  const [roles, setRoles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setRoles([]);
      setLoading(false);
      return;
    }

    const fetchRoles = async () => {
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id);

      if (!error && data) {
        setRoles(data.map(r => r.role));
      }
      setLoading(false);
    };

    fetchRoles();
  }, [user]);

  const isAdmin = roles.includes('admin');
  const isProgramManager = roles.includes('program_manager');
  const isViewer = roles.includes('viewer');
  const isFounder = roles.includes('founder');
  const isStaff = isAdmin || isProgramManager;
  const canEdit = isAdmin || isProgramManager;

  return { roles, loading, isAdmin, isProgramManager, isViewer, isFounder, isStaff, canEdit };
}
